const path = '$recipient'

export const RECIPIENT_INIT = `${path}/init`
export const RECIPIENT_LOADING = `${path}/loading`
export const RECIPIENT_COMPANY_CHANGE = `${path}/company/change`
export const RECIPIENT_VIEW_MODE = `${path}/view/mode`
export const RECIPIENT_DEPT_LIST = `${path}/tree/list`
export const RECIPIENT_DEPT_PATH = `${path}/tree/path`
export const RECIPIENT_DEPT_SELECT = `${path}/dept/select`
export const RECIPIENT_DEPT_TOGGLE = `${path}/dept/toggle`
export const RECIPIENT_DEPT_UNSELECT = `${path}/dept/unselect`
export const RECIPIENT_USER_TOGGLE = `${path}/user/toggle`
export const RECIPIENT_USER_SELECT = `${path}/user/select`
export const RECIPIENT_USER_UNSELECT = `${path}/user/unselect`
export const RECIPIENT_USER_SELECTALL = `${path}/user/select-all`
export const RECIPIENT_USER_LIST = `${path}/user/list`
export const RECIPIENT_SEARCH = `${path}/user/search`
export const RECIPIENT_SEARCH_CANCEL = `${path}/user/search/cancel`
export const RECIPIENT_SEARCH_KEYWORD = `${path}/search/keyword`
export const RECIPIENT_COMPPANIES_LIST = `${path}/company/list`
export const RECIPIENT_CURRENT_COMPANY = `${path}/company/currentCompany`
